module.exports = __webpack_public_path__ + "media/dashboard/assets/images/microphone-off-057d06ea0dd8749d283a5a3a8b7e0113.svg";